export default {
  siteId: "21",
  siteName: "pl",
  site: "pl",
  lang: "Polish",
  langCode: "pl-PL",
  MediaType: "Obsługiwane typy plików to JPEG, JPG, PNG lub MP4.",
  RewardQa:
    "Odpowiedz na wszystkie poniższe pytania, aby otrzymać dodatkowe nagrody.",
  MoreQa: "Kliknij, aby wypełnić więcej pytań.",
  RewardsToast: "Twoja nagroda została pomyślnie zaksięgowana na Twoim koncie.",
  subscribe1:
    "Pomyślnie zrezygnowano z subskrypcji wiadomości marketingowych Cupshe PL.",
  subscribe2: "Nie chciałeś zrezygnować z subskrypcji?",
  subscribe3: "ZREZYGNUJ Z SUBSKRYPCJI",
  subscribe4:
    "Pomyślnie zapisałeś się ponownie do wiadomości marketingowych Cupshe PL.",
  "You're already on the list!": "Jesteś już na liście! :)",
  "Oops, there was a hiccup!Please try again.":
    "Ups, wystąpiła czkawka! Spróbuj ponownie.",
  unsubscribe: "wypisz się",
  continuesubscribe: "KONTYNUUJ SUBSKRYPCJĘ",
  trustsubscribe:
    "Dziękujemy za zaufanie, zapewnimy Ci lepsze usługi i tańsze produkty.",
  mailContact:
    'Prosimy o kontakt z działem <a href="https://pl.cupshe.com/pages/contact-us" class="contact_link">obsługi klienta</a> w celu uzyskania pomocy.',
  policyText:
    "*Pamiętaj, że po rezygnacji z subskrypcji możesz otrzymywać wiadomości e-mail zawierające informacje umowne dotyczące przyszłych zakupów online. Na przykład potwierdzenie zamówienia, powiadomienie o wysyłce, powiadomienie o zwrocie pieniędzy itp.)",
};
